import $ from "jquery";
import * as actions from "../actions/actions";
import { connect } from "react-redux";

import React from "react";
import sizeMe from "react-sizeme";

import AppsFeature from "./nounproject-appsfeature";
import IconAPICustomBlock from "./nounproject-customblock-icon-api";
import BestCollection from "./nounproject-best-collection";
import BlogCarousel from "./nounproject-blog-carousel";
import FeaturedCollection from "./nounproject-featured-collection";
import Footer from "./nounproject-footer";
import IconsForEverythingHeader from "./nounproject-icons-everything-header";
import CustomizationCustomBlock from "./nounproject-customblock-customization";
import DiversityCustomBlock from "./nounproject-customblock-diversity";
import NounProjectSearch from "./nounproject-search";
import Sticky from "react-stickynode";
import TentPoles from "./nounproject-tentpoles";
import UserCarousel from "./nounproject-creator-carousel";

require("../../sass/components/nounproject-homepage.sass");

class NounProjectHomepage extends React.Component {
    componentWillMount() {
        this.props.fetchFeaturedCollectionMetaData();
    }

    constructor(props) {
        super(props);

        // dismiss old welcome modal
        $("#welcome_screen .inner .button").on("click", e => {
            e.preventDefault();
            $("#welcome_screen").removeClass("visible");
        });

        this.state = {
            featuredCollections: [],
            searchBarZ: 1
        };
    }

    render() {
        if (this.props.featuredCollections.length > 0) {
            let handleStateChange = status => {
                if (status.status === Sticky.STATUS_FIXED) {
                    $("body").addClass("search-is-sticky");
                } else {
                    $("body").removeClass("search-is-sticky");
                }
            };

            return (
                <section className="homepage-container">
                    <IconsForEverythingHeader />
                    <Sticky
                        activeClass="stuck-searchbar"
                        onStateChange={handleStateChange}
                    >
                        <div className="homepage-search">
                            <NounProjectSearch />
                        </div>
                    </Sticky>
                    <BestCollection />
                    <TentPoles />
                    <CustomizationCustomBlock />
                    <FeaturedCollection
                        collectionIndex={0}
                        adSpace={true}
                        maxIcons={12}
                        collectionMetadata={this.props.featuredCollections}
                    />
                    <AppsFeature />
                    <FeaturedCollection
                        collectionIndex={1}
                        maxIcons={12}
                        collectionMetadata={this.props.featuredCollections}
                    />
                    <DiversityCustomBlock />
                    <FeaturedCollection
                        collectionIndex={2}
                        maxIcons={12}
                        collectionMetadata={this.props.featuredCollections}
                    />
                    <UserCarousel />
                    <FeaturedCollection
                        collectionIndex={3}
                        maxIcons={12}
                        collectionMetadata={this.props.featuredCollections}
                    />
                    <IconAPICustomBlock />
                    <FeaturedCollection
                        collectionIndex={4}
                        maxIcons={12}
                        collectionMetadata={this.props.featuredCollections}
                    />
                    <BlogCarousel />
                    <Footer />
                </section>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state, ownProps) {
    let featuredCollections = [];

    if (state.collections.keys) {
        state.collections.keys.forEach(collectionId => {
            featuredCollections.push(state.collections[collectionId]);
        });
    }

    return { featuredCollections };
}

export default connect(mapStateToProps, {
    fetchFeaturedCollectionMetaData: actions.fetchFeaturedCollectionMetaData
})(sizeMe()(NounProjectHomepage));
